import { useCallback, useEffect, useMemo } from 'react'
import useSingleFlightRequest from 'components/DataGrid/useSingleFlightRequest'

export default function useLeadsRequest<T>(url: string, body: object, refreshKey: number) {
  const fetcher = useCallback(
    async ({ requestBodyJson }: { requestBodyJson: string }) => {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
        body: requestBodyJson,
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch ${url}: ${response.status}`)
      }

      return response.json() as Promise<T>
    },
    [url]
  )

  const { data, error, loading, run } = useSingleFlightRequest<{ requestBodyJson: string }, T>({
    request: fetcher,
  })

  const bodyJson = useMemo(() => JSON.stringify(body), [body])
  const key = useMemo(() => `${refreshKey}:${bodyJson}`, [refreshKey, bodyJson])

  useEffect(() => {
    run({ requestBodyJson: bodyJson })
  }, [run, key, bodyJson])

  return { data, error, loading }
}
